// Formatea un período (start, end) en YYYY-MM-DD a un texto compacto.
// Si start es el 1ro de un mes y end es el último día del MISMO mes →
// "Marzo 2026" (90% de los costos van a ser month-aligned).
// Si no → "1 mar 2026 — 31 mar 2026".
//
// Importante: parseamos como fecha local (NO new Date(string), que interpreta
// como UTC y desplaza un día en CR). Construimos con Date(y, m, d).

import { format } from "date-fns";
import { es } from "date-fns/locale";

function parseLocalDate(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m?.[1] || !m[2] || !m[3]) return null;
  const y = Number.parseInt(m[1], 10);
  const month = Number.parseInt(m[2], 10);
  const day = Number.parseInt(m[3], 10);
  return new Date(y, month - 1, day);
}

function lastDayOfMonth(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
}

export function formatPeriod(start: string, end: string): string {
  const startDate = parseLocalDate(start);
  const endDate = parseLocalDate(end);
  if (!startDate || !endDate) return `${start} — ${end}`;

  const sameMonth =
    startDate.getFullYear() === endDate.getFullYear() &&
    startDate.getMonth() === endDate.getMonth();

  const startsOnFirst = startDate.getDate() === 1;
  const endsOnLast = endDate.getDate() === lastDayOfMonth(endDate);

  if (sameMonth && startsOnFirst && endsOnLast) {
    const monthName = format(startDate, "MMMM yyyy", { locale: es });
    return monthName.charAt(0).toUpperCase() + monthName.slice(1);
  }

  return `${format(startDate, "d MMM yyyy", { locale: es })} — ${format(endDate, "d MMM yyyy", { locale: es })}`;
}

// Helper inverso para defaults del formulario: primer día del mes corriente
// y "hoy" en formato YYYY-MM-DD local.
export function isoLocalDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function firstDayOfCurrentMonth(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
}
